import ApiSlice, { ApiTag } from './ApiSlice';

const PrintersApi = ApiSlice.injectEndpoints({
  endpoints: (build) => ({
    getPrinters: build.query({
      query: () => ({
        method: 'GET',
        url: '/staff/printers',
      }),
      // Nothing else re-runs this query on its own: the app-wide subscription in
      // PrintProvider never goes cold, and the cache is not persisted. A single dropped
      // request at login would otherwise leave printsExternally false for the whole
      // session and route every receipt to the built-in head instead.
      extraOptions: { maxRetries: 3 },
      // The endpoint answers with a resource collection (`{ data: [...] }`) — unwrap it
      // once here so every consumer downstream gets a plain array.
      transformResponse: (response) => response?.data ?? response ?? [],
      providesTags: [ApiTag.Printers],
    }),

    createPrinter: build.mutation({
      query: (data) => ({
        method: 'POST',
        url: '/staff/printers',
        data,
      }),
      invalidatesTags: [ApiTag.Printers],
    }),

    updatePrinter: build.mutation({
      query: (data) => ({
        method: 'PUT',
        url: `/staff/printers/${data?.id}`,
        data,
      }),
      invalidatesTags: [ApiTag.Printers],
    }),

    deletePrinter: build.mutation({
      query: (data) => ({
        method: 'DELETE',
        url: `/staff/printers/${data?.id}`,
      }),
      invalidatesTags: [ApiTag.Printers],
    }),
  }),
});

export const { useCreatePrinterMutation, useDeletePrinterMutation, useGetPrintersQuery, useUpdatePrinterMutation } =
  PrintersApi;

export default PrintersApi;
